import { createFileRoute } from "@tanstack/react-router";
import { ImportacaoExtratoPage } from "@/pages/ImportacaoExtratoPage";

export const Route = createFileRoute("/importacoes/extratos")({
  head: () => ({
    meta: [
      { title: "Importar Extrato — AXIS Comprovantes" },
      { name: "description", content: "Importe um arquivo de extrato bancário em poucas etapas." },
    ],
  }),
  component: ImportacaoExtratoPage,
});
